import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Record } from "appworks/model/gameplay/records/record";
import { RecordBuilder } from "appworks/server/builders/record-builder";
import { lastInArray } from "appworks/utils/collection-utils";
import { gamevyPartnerConnectSpinRecordBuilder } from "gamevy/integration/builders/records/gamevy-partner-connect-spin-record-builder";
import { GamevyGameSchema, GamevySpinResponseSchema } from "gamevy/integration/schema/gamevy-spin-response-schema";
import { PartnerConnectSpinRequestPayload } from "partner-connect/integration/schema/partner-connect-spin-schema";
import { PartnerConnect } from "partner-connect/partner-connect-manager";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { AnticipationSupplement } from "slotworks/model/gameplay/supplements/anticipation-supplement";
import { GridOnlySupplement } from "slotworks/model/gameplay/supplements/grid-only-supplement";
import { TGRBigSymbolSupplement } from "supplements/tgr-big-symbol-supplement";
import { TGRInstantWinsSupplement } from "supplements/tgr-instant-wins-supplement";
import { tgrPartnerConnectSpinRecordBuilder } from "./tgr-partner-connect-spin-record-builder";

export class TGRHybridSpinRecordBuilder implements RecordBuilder {

    public id: string = "TGRHybridSpinRecordBuilder";

    public filter(request: PartnerConnectSpinRequestPayload, response: PartnerConnect.SpinResponse): boolean {
        return request instanceof PartnerConnectSpinRequestPayload && request.type !== "restore" && request.type !== "history" && request.cmd !== "C" && response !== undefined;
    }

    public build(gameplay: Gameplay, request: PartnerConnectSpinRequestPayload, response: PartnerConnect.SpinResponse): Record[] {
        const pcRecords = tgrPartnerConnectSpinRecordBuilder.build(gameplay, request, response);
        const allRecords = [];

        response.wager.bets.forEach((betObj: any, index: number) => {
            const hybridResponse: any = Object.assign({
                data: {
                    game: betObj.eventdata.response.clientData as GamevyGameSchema
                } as GamevySpinResponseSchema
            }, response);

            const record = gamevyPartnerConnectSpinRecordBuilder.build(gameplay, request, hybridResponse)[0];

            new TGRBigSymbolSupplement().process(record);
            new TGRInstantWinsSupplement().process(record);
            new GridOnlySupplement().process(record);
            new AnticipationSupplement().process(record);

            allRecords.push(record);
        });

        // pc/g hybrid root/trigger record
        allRecords[0] = Object.assign(pcRecords[0], allRecords[0]);
        const hybridRecord: SpinRecord = allRecords.splice(0, 1)[0];

        // add free spins to tree if necessary
        if (allRecords.length > 0) {
            hybridRecord.hasChildren = true;
            hybridRecord.lastChild = true;
            allRecords.forEach((childRecord: FreespinRecord) => childRecord.parent = hybridRecord);
            hybridRecord.children.push(...allRecords);
            lastInArray(hybridRecord.children).lastChild = true;
        }

        return [ hybridRecord ];
    }
}

export const tgrHybridSpinRecordBuilder = new TGRHybridSpinRecordBuilder();
